import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatingSliderComponent } from '@shared/oct-components/rating-slider/rating-slider.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';


@NgModule({
  declarations: [RatingSliderComponent],
  imports: [
    CommonModule,
    NgxSliderModule
  ],
  exports: [RatingSliderComponent]
})
export class RatingSliderModule {
}
